<template>
  <div
    id="app"
    class="app"
    :data-replay-blocked="replayBlocked">
    <six-header> </six-header>
    <router-view />
    <six-toast-container></six-toast-container>
    <consent-preferences />
  </div>
</template>

<script>
import SixHeader from "../six-ui-components/sixHeader.vue";
import SixToastContainer from "../six-ui-components/sixToastContainer.vue";
import ConsentPreferences from "../components/ConsentPreferences.vue";
import {isReplayRouteAllowed} from "../services/analytics";

export default {
  name: "app",
  components: {SixHeader, SixToastContainer, ConsentPreferences},
  computed: {
    replayBlocked() {
      return !isReplayRouteAllowed(this.$route);
    },
  },
};
</script>

<style lang="scss">
@import "../styles.css";

body {
  height: 100%;

  #app {
    height: 100%;
  }
}
</style>
˚
